export type ThirdPartyFormsStatusValue =
  | 'draft'
  | 'finalised'
  | 'pending'
  | 'pending requisition'
  | 'pending approval'
  | 'rejected'
  | 'accepted'
  | 'accepted ec'
  | 'accepted fc'
  | 'approved'
  | 'archived'

export type ThirdPartyFormsStatusItem = {
  value: ThirdPartyFormsStatusValue
  label: string
  backgroundColor: string
  color: string
}

export const THIRD_PARTY_FORMS_STATUS_ITEMS: ThirdPartyFormsStatusItem[] = [
  { value: 'draft', label: 'DRAFT', backgroundColor: '#C5CBD7', color: '#051C33' },
  { value: 'finalised', label: 'FINALISED', backgroundColor: '#DFD1B6', color: '#051C33' },
  { value: 'pending', label: 'PENDING', backgroundColor: '#C35309', color: '#FFFFFF' },
  { value: 'pending requisition', label: 'PENDING REQUISITION', backgroundColor: '#C35309', color: '#FFFFFF' },
  { value: 'pending approval', label: 'PENDING APPROVAL', backgroundColor: '#C35309', color: '#FFFFFF' },
  { value: 'rejected', label: 'REJECTED', backgroundColor: '#D43D4D', color: '#FFFFFF' },
  { value: 'accepted', label: 'ACCEPTED', backgroundColor: '#4467B8', color: '#FFFFFF' },
  { value: 'accepted ec', label: 'ACCEPTED EC', backgroundColor: '#4467B8', color: '#FFFFFF' },
  { value: 'accepted fc', label: 'ACCEPTED FC', backgroundColor: '#4467B8', color: '#FFFFFF' },
  { value: 'approved', label: 'APPROVED', backgroundColor: '#377F86', color: '#FFFFFF' },
  { value: 'archived', label: 'ARCHIVED', backgroundColor: '#B1B9CA', color: '#FFFFFF' }
]

export const THIRD_PARTY_FORMS_STATUS_FALLBACK: { backgroundColor: string; color: string } = {
  backgroundColor: '#B1B9CA',
  color: '#FFFFFF'
}

export const THIRD_PARTY_FORMS_STATUS_BY_VALUE: Record<string, ThirdPartyFormsStatusItem> =
  THIRD_PARTY_FORMS_STATUS_ITEMS.reduce(
    (acc, item) => {
      acc[item.value] = item
      return acc
    },
    {} as Record<string, ThirdPartyFormsStatusItem>
  )
